/* Endorphi buy box: live price in the add to cart button, per day
   price line, mobile sticky add to cart and compact mobile badges.
   Reads everything from the page, so it follows variant and
   subscription changes made by Dawn and Seal Subscriptions. */
(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('product-info')).filter(function (el) {
    return el.querySelector('.product__info-container') && !el.dataset.endorphiInit;
  });
  roots.forEach(function (root) {
    root.dataset.endorphiInit = '1';
    initBuyBox(root, /^MainProduct-/.test(root.id || ''));
  });

  function initBuyBox(root, isMain) {

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  var locale = (window.Shopify && Shopify.locale) || 'en';

  function formatCents(cents) {
    try {
      return new Intl.NumberFormat(locale + '-AU', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function selectedPack() {
    var input = root.querySelector('.endorphi-packs input:checked');
    if (!input) return null;
    var label = root.querySelector('label[for="' + input.id + '"]');
    if (!label) return null;
    return {
      name: label.dataset.packName || input.value,
      price: parseInt(label.dataset.price, 10) || 0,
      qty: parseInt(label.dataset.qty, 10) || 0,
    };
  }

  function currentPriceText() {
    var seal = root.querySelector('.sls-option-container.sls-active .sls-price .money');
    if (seal && seal.textContent.trim()) return seal.textContent.trim();
    var last = root.querySelector('[id^="price-"] .price-item--last');
    return last ? last.textContent.trim() : '';
  }

  /* 1. Price inside the add to cart button */
  function updateButton() {
    var btn = root.querySelector('.product-form__submit');
    if (!btn) return;
    var span = btn.querySelector('.atc-price');
    if (!span) {
      span = document.createElement('span');
      span.className = 'atc-price';
      var first = btn.querySelector(':scope > span');
      if (first) first.insertAdjacentElement('afterend', span);
      else btn.appendChild(span);
    }
    var text = currentPriceText();
    if (span.textContent !== text) span.textContent = text;
  }

  /* 2. Per day line (only on templates that set data-days-per-unit) */
  function updatePerDay() {
    var el = root.querySelector('.cpr-price-anchor[data-days-per-unit]');
    var pack = selectedPack();
    if (!el || !pack || !pack.qty || !pack.price) return;
    var daysPerUnit = parseInt(el.dataset.daysPerUnit, 10) || 30;
    var days = pack.qty * daysPerUnit;
    var perDay = Math.ceil(pack.price / days);
    var perDayText = perDay < 100 && /AUD|USD|NZD|CAD/.test(currency) ? perDay + '¢' : formatCents(perDay);
    var span = days >= 120 && days % 30 === 0 ? days / 30 + ' months' : days + ' days';
    el.innerHTML =
      '\uD83D\uDCA7 Less than <strong>' + perDayText + '/day</strong> for ' + span + ' ' + (el.dataset.suffix || '');
  }

  /* 3. Sticky add to cart (mobile) */
  var sticky = isMain ? document.getElementById('EndorphiStickyAtc') : null;
  var stickyVisible = false;
  function updateSticky() {
    if (!sticky) return;
    var pack = selectedPack();
    var packEl = sticky.querySelector('.endorphi-sticky-atc__pack');
    var priceEl = sticky.querySelector('.endorphi-sticky-atc__price');
    if (packEl && pack) packEl.textContent = pack.name;
    if (priceEl) priceEl.textContent = currentPriceText();
    var main = root.querySelector('.product-form__submit');
    var stickyBtn = sticky.querySelector('.endorphi-sticky-atc__btn');
    if (main && stickyBtn) stickyBtn.disabled = main.hasAttribute('disabled');
  }
  function setStickyVisible(show) {
    if (!sticky || show === stickyVisible) return;
    stickyVisible = show;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('has-sticky-atc', show);
  }
  if (sticky) {
    sticky.querySelector('.endorphi-sticky-atc__btn').addEventListener('click', function () {
      var main = root.querySelector('.product-form__submit');
      if (main && !main.hasAttribute('disabled')) main.click();
    });
    var watchTarget = root.querySelector('.product-form__buttons');
    if (watchTarget && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          setStickyVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(watchTarget);
    }
  }

  /* 4. Compact badge row on mobile (badge app renders in shadow DOM) */
  function styleBadges(tries) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var host = root.querySelector('section-store--badge-block');
    var sr = host && host.shadowRoot;
    if (!sr || !sr.querySelector('.cards')) {
      if ((tries || 0) < 20) setTimeout(function () { styleBadges((tries || 0) + 1); }, 250);
      return;
    }
    if (sr.querySelector('style[data-endorphi]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-endorphi', '');
    st.textContent =
      '.cards{flex-wrap:nowrap!important;overflow-x:auto;gap:6px!important;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
      '.cards::-webkit-scrollbar{display:none}' +
      '.card{flex:0 0 auto!important;padding:5px 10px!important}' +
      '.title{font-size:11px!important;white-space:nowrap}' +
      '.icon,.icon svg{width:13px!important;height:13px!important}';
    sr.appendChild(st);
  }

  var queued = false;
  function refresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      updateButton();
      updatePerDay();
      updateSticky();
    });
  }

  refresh();
  styleBadges(0);
  setTimeout(refresh, 800);
  setTimeout(refresh, 2500);
  new MutationObserver(refresh).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'checked'] });
  root.addEventListener('change', refresh);
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.variantChange, refresh);
  }
})();
